<template>
  <QcNotice tone="warn" icon="pi-exclamation-triangle" data-testid="qc-beta-note">
    <!--
      BETA as a note nobody can hover past (prototype v3's betaNote). It sits in
      the file card and at the foot of "Kuidas tähelepanekuid lugeda" — with the
      badge's tooltip that is three places, and design-spec §17.5 makes three
      the ceiling: more and people stop reading it.
    -->
    <strong class="font-semibold text-gray-700">{{ $t('messages.evaluation.qualityCheck.beta.noteLead') }}</strong>
    {{ ' ' }}
    <i18n-t keypath="messages.evaluation.qualityCheck.beta.note" tag="span" scope="global">
      <template #email>
        <a :href="`mailto:${supportEmail}`" class="text-blue-600 underline hover:text-blue-800">{{ supportEmail }}</a>
      </template>
    </i18n-t>
  </QcNotice>
</template>

<script setup>
import QcNotice from './QcNotice.vue'

defineProps({
  supportEmail: { type: String, required: true },
})
</script>
